import { render, staticRenderFns } from "./communityGuidelines.vue?vue&type=template&id=17458cf0&scoped=true&"
var script = {}
import style0 from "./communityGuidelines.vue?vue&type=style&index=0&id=17458cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17458cf0",
  null
  
)

export default component.exports